import React, { useEffect, useState, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import ColorClarityGrid from "./colorClarityGrid"; // Drilldown Component
import { cn, convertToJsonObject, getBgColor, getPercentile, mergeFilters, roundToGrossMargin, transformFilters } from "../utils/utils";
import Tooltip from "@mui/material/Tooltip";
import Cookies from 'js-cookie';
import { MdEdit } from "react-icons/md";
import { 
  FormControl, 
  Select, 
  MenuItem, 
  InputLabel,
  Radio,
  RadioGroup,
  FormControlLabel,
  Card,
  CardContent
} from "@mui/material";
import { setAlertText, setSeverity, setToast } from "../redux/slices/commonComponentSlice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircle2, ChevronRight, LayoutGrid, TableIcon, XCircle, TrendingUp, Package, BarChart3, Target } from "lucide-react/dist/cjs/lucide-react";
import { apiSlice } from "../redux/slices/apiSlice";
import { FiExternalLink } from "react-icons/fi";
import { pricing, setIsPreFiltered, setPreDefinedFilter } from "../redux/slices/pricingSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { selectShapeCaratState, setSelectedCaratRange, setSelectedCell, setSelectedMetric, setSelectedNeedsMetric, setSelectedShape } from "../redux/slices/shapeCaratSlice";
import DownloadNeeds from "./DownloadNeeds";
import amplitude from "../utils/ampli";
import BiAnalysisTable from "./BIAnalysis/BIAnalysisTable";
import MetricsPagesCardMUI from "./metricSummaryUI";
import { FaInfoCircle } from "react-icons/fa";

const ShapeCaratGrid = ({
  showLoadingTable,
  isLab,
  accountDetails,
  isCsr,
  caratRanges,
  tableViewData,
  shapes,
  gridData,
  dateRange,
  onDateRangeChange,
  data,
  metaSummary,
  defaultTurn,
  isResetting,
  setViewMode,
  defaultInterest,
  viewMode,
  defaultMetric = "turn", // Default metric set to "needs"
  defaultNeedsMetric = "needs", // Default metric set to "needs"
}) => {
  let isAdmin = isCsr || accountDetails.roles.includes("csr_admin") || accountDetails.roles.includes("account_admin");
  let isMFG = accountDetails.is_mfg_account;
  const filteredRedux = useSelector(pricing).filteredPerformance;
  // useEffect(() => {
  //   if (filteredRedux?.length === 0) {
  //     setQueryParams((prevParams) => ({
  //       ...prevParams,
  //       filters: convertToJsonObject(filteredRedux),
  //     }));
  //   }
  //   else{
  //     setQueryParams(prev => ({
  //       ...prev,
  //       filters: convertToJsonObject(filteredRedux),
  //     }));
  //   }
  // }, [filteredRedux]);
  const customFiltersRaw = useSelector(pricing)?.config?.custom_filters ?? [];
  const [hoveredGroup, setHoveredGroup] = useState([null, null]); // Hovered group state
  const [idealTurn, setIdealTurn] = useState(defaultTurn);
  const [idealInterest, setIdealInterest] = useState(defaultInterest);
  const [isEditing, setIsEditing] = useState(false);
  const [isEditingInterest, setIsEditingInterest] = useState(false);
  const [tempTurn, setTempTurn] = useState(defaultTurn);
  const [tempInterest, setTempInterest] = useState(defaultInterest);
  const drilldownRef = useRef(null);
  const dispatch = useDispatch();
  const {
    selectedShape,
    selectedCaratRange,
    selectedCell,
    selectedMetric,
    selectedNeedsMetric
  } = useSelector(selectShapeCaratState);

  const navigate = useNavigate();
  // const [queryParams, setQueryParams] = useState({
  //   id: accountDetails.account_id,
  //   startDate: dateRange.startDate,
  //   endDate: dateRange.endDate,
  //   shape: selectedCell?.shape,
  //   carat_range: selectedCell?.caratRange,
  //   caratRange: selectedCell?.caratRange,
  //   filters: convertToJsonObject(filteredRedux)
  // });

  const queryParams = useMemo(() => ({
  id: accountDetails.account_id,
  startDate: dateRange.startDate,
  endDate: dateRange.endDate,
  shape: selectedCell?.shape ?? selectedShape,
  carat_range: selectedCell?.caratRange ?? selectedCaratRange,
  caratRange: selectedCell?.caratRange ?? selectedCaratRange,
  filters: convertToJsonObject(filteredRedux, customFiltersRaw,isLab),
}), [
  accountDetails.account_id,
  dateRange,
  selectedCell,
  selectedShape,
  selectedCaratRange,
  filteredRedux,
]);




 // Date Picker sensitivity
 const [tempDateRange, setTempDateRange] = useState(dateRange);
 const [isSelecting, setIsSelecting] = useState(false);
 useEffect(() => {
   if (!isSelecting) {
     setTempDateRange(dateRange);
   }
 }, [dateRange]);

 const handleDateChange = (field, value) => {
   setIsSelecting(true);
   setTempDateRange(prev => ({
     ...prev,
     [field]: value
   }));
 };

 const handleApply = () => {
   setIsSelecting(false);
   if (tempDateRange.startDate && tempDateRange.endDate) {
     onDateRangeChange(tempDateRange);
     const url = new URL(window.location);
     url.searchParams.set("sd", tempDateRange.startDate);
     url.searchParams.set("ed", tempDateRange.endDate);
     window.history.replaceState({}, "", url);
   }
 };

 const handleCancel = () => {
   setIsSelecting(false);
   setTempDateRange(dateRange); // Reset to original values
 };
 

  const [shapeCaratFilter, setShapeCaratFilter] = useState({
    discrete: {
      "diamond#shape": [selectedCell?.shape],
      "gem#carats": [
      {
        "from": selectedCell?.caratRange.split('-')[0],
        "to": selectedCell?.caratRange.split('-')[1]
      }
    ]
    }})
  const [allShape, setAllShape] = useState({
    discrete: {
      "diamond#shape": [],
    }})
  const [allCarat, setAllCarat] = useState({
    discrete: {
      "gem#carats": [
      {
        "from": {},
        "to": {}
      }
    ]
    }})



const getCellStyle = (bgColor, shape, range) => {
  const isSelected = selectedCell?.shape === shape && selectedCell?.caratRange === range;
  return {
    backgroundColor: bgColor,
    color: "#000",
    border: isSelected ? "2px solid #000" : "1px solid #ccc",
    // position: "relative",
    // transition: "all 0.2s ease",
    // boxShadow: isSelected ? "0 0 8px rgba(0,0,0,0.3)" : "none",
    // transform: isSelected ? "scale(1.05)" : "scale(1)"
  };
};
// useEffect(() => {
//   if (selectedShape && selectedCaratRange) {
//     setQueryParams(prev => ({
//       ...prev,
//       id: accountDetails.account_id,
//       startDate: dateRange.startDate,
//       endDate: dateRange.endDate,
//       shape: selectedShape,
//       carat_range: selectedCell.caratRange,
//     }));
//   }
// }, [dateRange, selectedCell, queryParams.filters]);

  


// useEffect(() => {
//   Create a function to update query params
//   const updateQueryParams = (updates) => {
//     setQueryParams(prev => ({
//       ...prev,
//       id: accountDetails.account_id,
//       startDate: dateRange.startDate,
//       endDate: dateRange.endDate,
//       ...updates
//     }));
//   };

//   If a cell is selected, update shape and carat_range
//   if (selectedCell) {
//     updateQueryParams({
//       shape: selectedCell.shape || selectedShape,
//       carat_range: selectedCell.caratRange || selectedCaratRange,
//     });
//   }
// }, [selectedCell]);

  const handleMetricChange = (metric) => {
    dispatch(setSelectedMetric(metric));
    const buttonClickedEvent = {
      event_type: `v3_metric_change`,
      value: metric,
    };
  amplitude.track(buttonClickedEvent);
  };

  const handleNeedsMetricChange = (metric) => {
    dispatch(setSelectedNeedsMetric(metric));
    const buttonClickedEvent = {
      event_type: `v3_needs_metric_change`,
      value: metric,
    };
  amplitude.track(buttonClickedEvent);
  };

  const handleCellClick = (shapeIndex, caratIndex) => {
      const shape = shapes[shapeIndex];
      const caratRange = caratRanges[caratIndex];
      
        // setQueryParams((prevParams) => ({
        //   ...prevParams,
        //   shape: shape,
        //   caratRange: caratRange,
        // }));
        dispatch(setSelectedShape(shape));
        dispatch(setSelectedCaratRange(caratRange));
        dispatch(setSelectedCell({ shape, caratRange }));
        const url = new URL(window.location);
        url.searchParams.set("sh", shape);
        url.searchParams.set("cr", caratRange);
        window.history.replaceState({}, "", url);
                const buttonClickedEvent = {
          event_type: `v3_shape_carat_cell_click`,
          value: { shape, caratRange },
        };

        amplitude.track(buttonClickedEvent);
        setShapeCaratFilter({
          discrete: {
            "diamond#shape": [shape],
            "gem#carats": [
              {
                from: caratRange.split('-')[0],
                to: caratRange.split('-')[1],
              }],
          },
        });

        // Smooth scroll to drilldown component after a brief delay
        setTimeout(() => {
          drilldownRef.current?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
  };

    function roundIfFloat(value) {
          // Check if the value is a number and if it has a decimal part
          if (typeof value === 'number' && value % 1 !== 0) {
            // Round the number to 2 decimal places
            return Math.round(value * 100) / 100;
          }
          // Return the value as it is if it's not a float
          return value;
    }

  // write a function to return number with one decimal place for any given number or integer
    function roundToOneDecimal(value) {
          return (Math.round(value * 10) / 10).toFixed(1);
      }
    
    function roundToTwoDecimal(value) {
          return (Math.round(value * 10) / 10).toFixed(2);
    }  

    function roundToZeroDecimal(value) {
        return (Math.round(value * 10) / 10).toFixed(0);
    }


    const handleShapeChange = (newShape) => {
      dispatch(setSelectedShape(newShape));
      const shapeIndex = shapes.indexOf(newShape);
      const caratIndex = caratRanges.indexOf(selectedCaratRange);
    
      if (shapeIndex !== -1 && caratIndex !== -1) {

        dispatch(setSelectedCell({
          shape: newShape,
          caratRange: selectedCaratRange,
        }));
      }
      
      // Update shapeCaratFilter with the new shape
      setShapeCaratFilter((prevFilter) => ({
        ...prevFilter,
        discrete: {
          ...prevFilter.discrete,
          "diamond#shape": [newShape],
        },
      }));

      const url = new URL(window.location);
        url.searchParams.set("sh", newShape);
        url.searchParams.set("cr", selectedCaratRange);
        window.history.replaceState({}, "", url);

      const buttonClickedEvent = {
        event_type: `v3_shape_change_dropdown`,
        value: [newShape],
      };
      amplitude.track(buttonClickedEvent);
    };
        
    const handleCaratChange = (newCaratRange) => {
      dispatch(setSelectedCaratRange(newCaratRange));
    
      // setQueryParams((prevParams) => ({
      //   ...prevParams,
      //   caratRange: newCaratRange,
      // }));
    
      dispatch(setSelectedCell({
        shape: selectedShape,
        caratRange: newCaratRange,
      }))
    
      // Update shapeCaratFilter with the new carat range
      setShapeCaratFilter((prevFilter) => ({
        ...prevFilter,
        discrete: {
          ...prevFilter.discrete,
          "gem#carats": [
            {
              from: newCaratRange.split('-')[0],
              to: newCaratRange.split('-')[1],
            },
          ],
        },
      }));

        const url = new URL(window.location);
          url.searchParams.set("sh", selectedShape);
          url.searchParams.set("cr", newCaratRange);
          window.history.replaceState({}, "", url);
        const buttonClickedEvent = {
          event_type: `v3_carat_change_dropdown`,
          value: [newCaratRange],
        };
        amplitude.track(buttonClickedEvent);
    };

    const handleSaveIdealSearch = async () => {
      // setIsLoading(true);
      const currentTempTurn = tempTurn
      const baseUrl = `${process.env.REACT_APP_API_URL}/update_ideal_turn`;
      let token = Cookies.get("access_token");

      let data = {
          ideal_turn: currentTempTurn,
      };
      
      try {
        const response = await axios.post(`${baseUrl}?`, data,{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", 
            "ngrok-skip-browser-warning": "true",
          },
        });
        const buttonClickedEvent = {
                event_type: `v3_update_ideal_turn`,
                value: data,
              };
            amplitude.track(buttonClickedEvent);
        setIdealTurn(tempTurn); // Update idealTurn only on success
        setIsEditing(false);
        dispatch(setToast(true));
        dispatch(setAlertText(response?.data.message));
        dispatch(setSeverity("success"));
        dispatch(apiSlice.util.invalidateTags(["shapeSizeTable"]));
        // console.log(response?.data.saved_search.pricing_saved_search)
      } catch (error) {
        dispatch(setToast(true));
        dispatch(setAlertText(error.response?.data?.errors.error[0] || "An error occurred"));
        dispatch(setSeverity("error"));
      } finally {
        // setIsLoading(false);
      }
    }

    const handleSaveInsterestRate = async () => {
      // setIsLoading(true);
      const currentTempTurn = tempInterest
      const baseUrl = `${process.env.REACT_APP_API_URL}/update_ideal_turn`;
      let token = Cookies.get("access_token");

      let data = {
          interest_rate: currentTempTurn,
      };
      
      try {
        const response = await axios.post(`${baseUrl}?`, data,{
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", 
            "ngrok-skip-browser-warning": "true",
          },
        });
        const buttonClickedEvent = {
                event_type: `v3_update_ideal_turn`,
                value: data,
              };
            amplitude.track(buttonClickedEvent);
        setIdealInterest(tempInterest); // Update idealTurn only on success
        setIsEditingInterest(false);
        dispatch(setToast(true));
        dispatch(setAlertText(response?.data.message));
        dispatch(setSeverity("success"));
        dispatch(apiSlice.util.invalidateTags(["shapeSizeTable"]));
        // console.log(response?.data.saved_search.pricing_saved_search)
      } catch (error) {
        dispatch(setToast(true));
        dispatch(setAlertText(error.response?.data?.errors.error[0] || "An error occurred"));
        dispatch(setSeverity("error"));
      } finally {
        // setIsLoading(false);
      }
    }

  //  value = {
  //   "discrete": {
  //     "diamond#shape": [
  //       "0007cushion_brilliant"
  //     ],
  //     "gem#carats": [
  //       {
  //         "from": "2.00",
  //         "to": "2.19"
  //       }
  //     ]
  //   }
  // }

  const handleSearchClick = (value) => {
    if (value.discrete["diamond#shape"]?.includes("0007cushion_brilliant")) {
      value.discrete["diamond#shape"].push("0008cushion_modified");
    }
        const discreteFilters = mergeFilters(convertToJsonObject(filteredRedux, customFiltersRaw,isLab),transformFilters(value));
        const buttonClickedEvent = {
          event_type: `v3_stock_performance_to_PCP_shape_carat`,
          value: discreteFilters,
        };
        amplitude.track(buttonClickedEvent);
        
        dispatch(setIsPreFiltered(true));
        dispatch(setPreDefinedFilter(discreteFilters));
        navigate(`/price_co-pilot?page=0`);
      }; 


  const handleShapeClick = (value) => {
      const newShapeState = {
        discrete: {
            "diamond#shape":value == "0007cushion_brilliant"?[value, "0008cushion_modified"]: [value],
        },
      };

        setAllShape(newShapeState); // Update state
      const discreteFilters = mergeFilters(convertToJsonObject(filteredRedux, customFiltersRaw,isLab),transformFilters(newShapeState)); // Use the updated state  
        dispatch(setIsPreFiltered(true));
        dispatch(setPreDefinedFilter(discreteFilters));
        const buttonClickedEvent = {
          event_type: `v3_shape_header_click_to_pcp`,
          value: discreteFilters,
        };
        amplitude.track(buttonClickedEvent);
        navigate(`/price_co-pilot?page=0`);
    }; 

  const handleCaratClick = (value) => {
    const newCaratState = {
      discrete: {
        "gem#carats": [
          {
            from: value.split('-')[0],
            to: value.split('-')[1],
          },
        ],
      },
    };

    setAllCarat(newCaratState); // Update state
    const discreteFilters = mergeFilters(convertToJsonObject(filteredRedux, customFiltersRaw, isLab),transformFilters(newCaratState)); // Use the updated state  
    dispatch(setIsPreFiltered(true));
    dispatch(setPreDefinedFilter(discreteFilters));
    const buttonClickedEvent = {
      event_type: `v3_carat_row_click_to_pcp`,
      value: discreteFilters,
    };
    amplitude.track(buttonClickedEvent);
    navigate(`/price_co-pilot?page=0`);
 }; 



    const formatTooltipPrice = (value) => {
      if (value == null || isNaN(value)) {
        return "0"; // Handle null, undefined, or NaN values
      }
      if (value >= 1_000_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      }
      return `$${value.toFixed(0)}`;
    };

    const formatTooltipPriceM = (value) => {
      if (value == null || isNaN(value)) {
        return "0"; // Handle null, undefined, or NaN values
      }

      if (value >= 1_000_000_000) {
        return `$${(value / 1_000_000_000).toFixed(1)}B`; // Billions
      } else if (value >= 1_000_000) {
        return `$${(value / 1_000_000).toFixed(1)}M`; // Millions
      } else if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(1)}K`; // Thousands
  }

  return `$${value.toFixed(0)}`;
};


    const formatPrice = (value) => {
      if (value >= 1_000_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      } else if (value >= 1_000) {
        return `$${(value / 1_000).toFixed(0)}K`;
      }
      return `<$1K`; // Default format for smaller values
    };

  return (
    <div className="shape-carat-grid">
      {/* Shape-Carat Grid */}
      <div className="grid-shape-size-container w-max flex-col items-center mx-auto justify-center ">
        <div className="controls flex justify-between w-full items-center mb-2">
          <div className="col-sm-8" style={{paddingLeft: '0'}}>
            <FormControl size="small">
              {/* <FormLabel id="metric-row-radio-buttons-group-label inline">Metric</FormLabel> */}
              <div className="flex gap-2 items-center justify-center" >
              <div className="flex justify-between  gap-3 items-center" style={{ minWidth: 450}}>
              {/* <InputLabel style={{overflow: 'visible'}}>Metric</InputLabel> */}
              {viewMode === "grid" &&
                (
                  <>
                     <Select
                value={selectedMetric}
                style={{ minWidth: 162 }}
                >
                {isAdmin
                  ? ["inventory", "sales", "needs", "turn", "current_turn", "overhang", "gross_margin", "gross_margin_roi"].map(
                      (metric) => (
                        <MenuItem
                          key={metric}
                          value={metric}
                          onClick={() => handleMetricChange(metric)}
                        >
                          {metric === "needs"
                            ? "Needs / Surplus"
                            : metric === "gross_margin_roi"
                            ? "GMROI"
                            : metric === "current_turn"
                            ? "Proj Turn"
                            : metric.charAt(0).toUpperCase() + metric.slice(1).replace("_", " ")}
                        </MenuItem>
                      )
                    )
                  : ["inventory", "sales", "needs", "turn", "current_turn", "overhang"].map((metric) => (
                      <MenuItem
                        key={metric}
                        value={metric}
                        onClick={() => handleMetricChange(metric)}
                      >
                        {metric === "needs"
                          ? "Needs / Surplus"
                          : metric === "current_turn"
                          ? "Proj Turn"
                          : metric.charAt(0).toUpperCase() + metric.slice(1).replace("_", " ")}
                      </MenuItem>
                    ))}
              </Select>
              {(selectedMetric === "gross_margin_roi" || selectedMetric === "gross_margin") && isAdmin && (
                <div className="flex  items-center">
                  <Tooltip title="Gross Margin Return on Inventory Investment, a profitability ratio that measures the gross profit generated for every dollar invested in inventory.">
                     <p><FaInfoCircle /></p>
                  </Tooltip>
                </div>
              )}

              <div  style={{ minWidth: 280 }}>
              {selectedMetric === "needs" && (
                <div className="flex  items-center">
                <RadioGroup
                  row
                  aria-labelledby="metric-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  size="small"
                >
                {["all", "needs", "surplus"].map((metric) => (
                  <FormControlLabel key={metric} value={metric} control={<Radio size="small"/>} label={metric.charAt(0).toUpperCase() + metric.slice(1)} checked={selectedNeedsMetric === metric} onChange={() => handleNeedsMetricChange(metric)}/>
                ))}
              </RadioGroup>
              
              {/* <DownloadNeeds accountDetails={accountDetails} selectedNeedsMetric={selectedNeedsMetric} startDate={dateRange.startDate} endDate={dateRange.endDate} /> */}
              </div>
              )}
              
              {(selectedMetric === "gross_margin_roi" || selectedMetric === "gross_margin")  && isAdmin && (
                
                <div className="flex  items-center">
                {!isEditingInterest ? (
                    <div className="flex items-center space-x-1">
                    <p>Interest Rate:</p>
                      <span className="text-gray-800 w-[60px] border px-1 py-[2px] rounded-md bg-slate-200 text-sm text-center">{idealInterest}</span>
                      <button
                        className="px-2 py-1 bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs hover:bg-blue-200 transition-colors duration-200 "
                        onClick={() => setIsEditingInterest(true)}
                      >
                        <MdEdit  height={"18px"} width={"18px"} />
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center space-x-1">
                    <p>Interest Rate:</p>
                      <input
                        className=" px-1 w-[60px] py-[2px] border rounded text-sm text-center"
                        value={tempInterest}
                        onChange={(e) => setTempInterest(e.target.value)}
                      />
                      <button
                        className="px-1 py-1  bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-green-500 self-end   hover:bg-green-200 transition-colors duration-200"
                        onClick={handleSaveInsterestRate}
                      >
                        <CheckCircle2 className="h-max" height={"18px"} width={"18px"} />
                      </button>
                      <button
                        className="px-1 py-1 bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-red-500  hover:bg-red-200 transition-colors duration-200 "
                        onClick={() => setIsEditingInterest(false)}
                      >
                        <XCircle height={"18px"} width={"18px"} />
                      </button>
                    </div>
                  )}
              </div>
           )}

              </div>
            </>)} 
          </div>
              
              {!isEditing ? (
                    <div className="flex items-center space-x-1">
                    <p>Ideal Turn:</p>
                      <span className="text-gray-800 w-[60px] border px-1 py-[2px] rounded-md bg-slate-200 text-sm text-center">{idealTurn}</span>
                      <button
                        className="px-2 py-1 bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs hover:bg-blue-200 transition-colors duration-200 "
                        onClick={() => setIsEditing(true)}
                      >
                        <MdEdit  height={"18px"} width={"18px"} />
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center space-x-1">
                    <p>Ideal Turn:</p>
                      <input
                        className=" px-1 w-[60px] py-[2px] border rounded text-sm text-center"
                        value={tempTurn}
                        onChange={(e) => setTempTurn(e.target.value)}
                      />
                      <button
                        className="px-1 py-1  bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-green-500 self-end   hover:bg-green-200 transition-colors duration-200"
                        onClick={handleSaveIdealSearch}
                      >
                        <CheckCircle2 className="h-max" height={"18px"} width={"18px"} />
                      </button>
                      <button
                        className="px-1 py-1 bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-red-500  hover:bg-red-200 transition-colors duration-200 "
                        onClick={() => setIsEditing(false)}
                      >
                        <XCircle height={"18px"} width={"18px"} />
                      </button>
                    </div>
                  )}
                          
               </div>
            </FormControl>
          </div>

          {/* Date Range Picker */}
          <div className="col-sm-4" style={{paddingRight: '0'}}>
            <div className="date-range-picker flex justify-end">
              <label className="me-2 flex justify-center items-center gap-2">
                From:{" "}
                <input
                  type="date"
                  value={tempDateRange.startDate}
                  max={tempDateRange.endDate}
                  onChange={(e) => handleDateChange('startDate', e.target.value)}
                  
                />
              </label>
              <label className="flex justify-center items-center gap-2 mr-1"  style={{marginRight: '0'}}>
                To:{" "}
                <input
                  type="date"
                  value={tempDateRange.endDate}
                  min={tempDateRange.startDate}
                  onChange={(e) => handleDateChange('endDate', e.target.value)}
                />
              </label>
              {isSelecting && (
                    <div className="flex items-start gap-1">
                    <Tooltip title="Submit your change in dates">
                      <button
                        onClick={handleApply}

                        className="px-1 py-1  bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-green-500 self-end   hover:bg-green-200 transition-colors duration-200"
                      >
                        <CheckCircle2 height={"18px"} width={"18px"} />
                      </button>
                      </Tooltip>
                      {/* <button
                        onClick={handleCancel}
                        className="px-1 py-1 bg-[#daf0ff] border-1 border-solid border-[#EAEAEA] rounded-md font-medium text-xs text-red-500  hover:bg-red-200 transition-colors duration-200"
                      >
                        <XCircle height={"18px"} width={"18px"} />
                      </button> */}
                    </div>
                  )}
            </div>
                

          </div>
        </div>
        <div className='flex gap-2 justify-between items-center mb-2'>
          <div className="flex pb-1 justify-between items-center w-full flex-wrap text-[0.75rem]">
           <div className="flex gap-[0.2rem] w-[1040px] justify-between items-center">
              {/* <p className="text-inherit text-base font-medium ">Summary:</p> */}

              {/* {
                isAdmin ? (
                  <span className=" text-[0.6959rem] pt-[0.2rem] font-medium">
                    Inventory: {metaSummary?.inventory} | Inv Value: {formatTooltipPriceM(metaSummary.inv_value)} |
                    Sales: {metaSummary?.sales} | Sold Value: {formatTooltipPriceM(metaSummary.sold_value)} | Turn: {roundIfFloat(metaSummary.turn)} | Overhang:
                    {roundToOneDecimal(metaSummary.overhang)} | Needs/Surplus: {roundToOneDecimal(metaSummary.needs)} | GMROI: {roundToGrossMargin(metaSummary.gross_margin_roi)}
                    | GM: {roundToGrossMargin(metaSummary.gross_margin)}
                 </span>) : (
                <span className=" text-[0.6959rem] pt-[0.2rem] font-medium">
                  Inventory: {metaSummary?.inventory} | Inv Value: {formatTooltipPriceM(metaSummary.inv_value)} |
                  Sales: {metaSummary?.sales} | Sold Value: {formatTooltipPriceM(metaSummary.sold_value)} | Turn: {roundIfFloat(metaSummary.turn)} | Overhang:
                  {roundToOneDecimal(metaSummary.overhang)} | Needs/Surplus: {roundToOneDecimal(metaSummary.needs)}
               </span>
              )
              } */}
              <MetricsPagesCardMUI metaSummary={metaSummary} isAdmin={isAdmin} roundToOneDecimal={roundToOneDecimal} roundToZeroDecimal={roundToZeroDecimal} formatTooltipPriceM={formatTooltipPriceM} />
              
           </div>
          </div>
          
        </div>

        { viewMode === "grid" && <div style={{ 
          maxHeight: "80vh", // Adjust this value based on your needs
          overflow: "scroll",
          position: "relative"
        }}>
        <table className="grid-shape-size self-center">
          <thead  className="" style={{
              position: "sticky",
              top: -1,
              zIndex: 1,
            }}>
            <tr>
              <th style={{ width: "75px" }}>Carat / Shape</th>
              {shapes.map((shape) => (
                <th onClick={() => handleShapeClick(shape)} key={shape} style={{cursor: "pointer"}}>{data[shape].trans}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          
            {caratRanges.map((range, caratIndex) => (
              <tr key={range}>
                <td onClick={() => handleCaratClick(range)} style={{ width: "10%", cursor: "pointer" }}>
                  <strong>{range}</strong>
                </td>
                {shapes.map((shape, shapeIndex) => {
                  let needs = gridData[shapeIndex][caratIndex].needs;
                  let value = gridData[shapeIndex][caratIndex][selectedMetric];
                  let invValue = gridData[shapeIndex][caratIndex]["inv_value"];
                  let soldValue = gridData[shapeIndex][caratIndex]["sold_value"];
                  if (selectedMetric === "needs") {
                    if (selectedNeedsMetric === "surplus") {
                      value = needs < 0 ? needs : null; // Show only surplus
                    } else if (selectedNeedsMetric === "needs") {
                      value = needs > 0 ? needs : null; // Show only shortfall
                    }
                    else{
                      value = needs; // Show all
                    }
                  }
                  // Use monetary values for heatmap when selectedMetric is inventory or sales
                  const colorMetricKey =
                    selectedMetric === "inventory"
                      ? "inv_value"
                      : selectedMetric === "sales"
                      ? "sold_value"
                      : selectedMetric;

                  let min = Math.min(
                    ...gridData.flat().map((cell) => cell[colorMetricKey])
                  );
                  let max = Math.max(
                    ...gridData.flat().map((cell) => cell[colorMetricKey])
                  );
                  let neutralValue = 0;
                  if(
                    colorMetricKey === "inv_value" ||
                    colorMetricKey === "sold_value" ||
                    colorMetricKey === "needs" ||
                    colorMetricKey === "gross_margin" ||
                    colorMetricKey === "gross_margin_roi"
                  ){
                    max = getPercentile(
                      gridData
                        .flat()
                        .map((cell) => cell[colorMetricKey])
                        .filter((v) => v > neutralValue),
                      95
                    );
                    if(
                      colorMetricKey === "needs" ||
                      colorMetricKey === "gross_margin" ||
                      colorMetricKey === "gross_margin_roi"
                    ){
                      min = getPercentile(
                        gridData
                          .flat()
                          .map((cell) => cell[colorMetricKey])
                          .filter((v) => v < neutralValue),
                        5
                      );
                    }
                  }
                  {/* in case of turn */}
                  {/* min is 0.5 * Ideal turn and this should be red */}
                  {/* max is 2 * Ideal turn and this should be green */}
                  {/* Ideal turn should be white */}
                  {/* const idealTurn = 1.4; */}
                  if(selectedMetric === "turn"){
                    neutralValue = idealTurn;
                    min = idealTurn * 0.5;
                    max = idealTurn * 2;
                  }
                  let reverseColoring = false
                  if(selectedMetric === "overhang"){
                    neutralValue = 365/idealTurn;
                    min = neutralValue * 0.5;
                    max = neutralValue * 2;
                    reverseColoring = true;
                  }
                  const valueForColor =
                    selectedMetric === "inventory"
                      ? invValue
                      : selectedMetric === "sales"
                      ? soldValue
                      : value;
                  let bgColor = getBgColor(min, max, valueForColor, neutralValue, 50, reverseColoring);
                  let costMissing = gridData[shapeIndex][caratIndex].cost_data_missing;
                  const tooltipContent = (
                    <>
                      <div className="flex pt-2 justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max self-center font-semibold text-[0.68rem]">{data[shape].trans} {range} | {gridData[shapeIndex][caratIndex].bucket.toUpperCase()}</div>
                      </div>
                      <hr className="p-0 h-0" />
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Inventory: </div>
                        <div className="text-left"><strong>{gridData[shapeIndex][caratIndex].inventory}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Inv Value: </div> 
                        <div className="text-left"><strong>{formatTooltipPrice(gridData[shapeIndex][caratIndex].inv_value)}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Sales:  </div>
                        <div className="text-left"><strong>{gridData[shapeIndex][caratIndex].sales}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Sold Value:  </div>
                        <div className="text-left"><strong>{formatTooltipPrice(gridData[shapeIndex][caratIndex].sold_value)}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Needs / Surplus:  </div>
                        <div className="text-left"><strong>{roundToZeroDecimal(roundIfFloat(needs))}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Turn:  </div>
                        <div className="text-left"><strong>{roundIfFloat(gridData[shapeIndex][caratIndex].turn)}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Projected Turn:  </div>
                        <div className="text-left"><strong>{roundIfFloat(gridData[shapeIndex][caratIndex].current_turn)}</strong></div>
                      </div>
                      {/* <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Bucket:  </div>
                        <div className="text-left"><strong>{gridData[shapeIndex][caratIndex].bucket ? gridData[shapeIndex][caratIndex].bucket.toUpperCase() : "-"}</strong></div>
                      </div> */}
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Overhang:  </div>
                        <div className="text-left">
                          <strong>
                            {gridData[shapeIndex] &&
                            gridData[shapeIndex][caratIndex] &&
                            gridData[shapeIndex][caratIndex]["inventory"] !== 0 &&
                            gridData[shapeIndex][caratIndex]["sales"] === 0
                              ? gridData[shapeIndex][caratIndex].inv_aging
                              : gridData[shapeIndex][caratIndex] &&
                                gridData[shapeIndex][caratIndex].overhang != null
                                ? roundIfFloat(gridData[shapeIndex][caratIndex].overhang).toFixed(0)
                                : "-"}
                          </strong>
                        </div>
                      </div>
                      {isAdmin && (<>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">Gross Margin:  </div>
                        <div className="text-left"><strong>{(gridData[shapeIndex][caratIndex].gross_margin === null) ? "-" : roundToGrossMargin(gridData[shapeIndex][caratIndex].gross_margin)}</strong></div>
                      </div>
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="w-max">GMROI:  </div>
                        <div className="text-left"><strong>{(gridData[shapeIndex][caratIndex].gross_margin_roi === null) ? "-" :roundToGrossMargin(gridData[shapeIndex][caratIndex].gross_margin_roi)}</strong></div>
                      </div>
                      </>
                      )}
                      {
                        costMissing && isAdmin && (selectedMetric === "gross_margin" || selectedMetric === "gross_margin_roi") && (
                      <>
                      <hr />
                      <div className="flex justify-between w-max items-center" style={{width: "154px"}}>
                        <div className="text-center"> Cost Price not available for all stones.</div>
                      </div>
                      </>)
                      }
                    </>
                  );
                  let displayValue = roundIfFloat(value);
                  
                  {/* if selectedMetric is "inventory" or "sales" and the value is 0 then show "-" */}
                  {/* if selectedMetric is "turn" and the inventory and sales values are 0 then show "-" */}
                  if(selectedMetric === "turn" ||  selectedMetric === "overhang"){
                    displayValue = roundToOneDecimal(value);
                  }
                  if(selectedMetric === "needs"){
                    displayValue = roundToZeroDecimal(value);
                  }
                  
                  if(selectedMetric === "overhang"){
                    if (value === null) {
                    displayValue = "-";
                    bgColor = "#fff";
                  }
                  else{
                    displayValue = value.toFixed(0);
                  }
                  }
                  if (value === null) {
                    displayValue = "-";
                    bgColor = "#fff";
                  }

                  if((selectedMetric === "inventory" || selectedMetric === "sales") && displayValue === 0){
                    displayValue = "-";
                    bgColor = "#fff";
                  }else if((selectedMetric === "turn") && gridData[shapeIndex][caratIndex]["inventory"] === 0){
                    if(gridData[shapeIndex][caratIndex]["sales"] === 0 ){
                      displayValue = "-";
                      bgColor = "#fff";
                    }else{
                      displayValue = (<>{displayValue}<sup>*</sup></>);
                      bgColor = getBgColor(min, max, gridData[shapeIndex][caratIndex]["turn"], neutralValue, 50);
                    }
                  }else if((selectedMetric === "overhang") && gridData[shapeIndex][caratIndex]["inventory"] === 0){
                    displayValue = "-";
                    bgColor = "#fff";
                  }else if((selectedMetric === "overhang") && gridData[shapeIndex][caratIndex]["inventory"] !== 0 && gridData[shapeIndex][caratIndex]["sales"] === 0){
                    displayValue = (<>{Math.floor(gridData[shapeIndex][caratIndex].overhang)}<sup>*</sup></>);
                    bgColor = "#fff";
                  }
                  return (
                    <Tooltip key={`${shape}-${range}`} title={tooltipContent} arrow placement="right-start" disableInteractive>
                      <td
                        key={shape}
                        style={getCellStyle(bgColor, shape, range)}
                        // style={{ backgroundColor: bgColor, color: "#000" }}
                        onClick={() => handleCellClick(shapeIndex, caratIndex)}
                        className={value === 0 ? (selectedMetric === "needs" ? "cursor-pointer" : "cursor-not-allowed") : `cursor-pointer ${costMissing && (selectedMetric === "gross_margin" || selectedMetric === "gross_margin_roi") ? "note" : ""}`}
                      >
                        
                        {selectedMetric === "inventory" && displayValue !== "-"
                                ? (
                                        <>
                                          <div style={{ textDecoration: "underline" }}>{displayValue}</div>
                                          <div style={{ fontSize: "9px" }}>{formatPrice(invValue)}</div>
                                        </>
                                      )
                                : selectedMetric === "sales" && displayValue !== "-"
                                  ? (
                                        <>
                                          <div style={{ textDecoration: "underline" }}>{displayValue}</div>
                                          <div style={{ fontSize: "9px" }}>{formatPrice(soldValue)}</div>
                                        </>
                                      )
                                
                                  : (selectedMetric === "gross_margin" || selectedMetric === "gross_margin_roi") && displayValue !== "-"
                                  ? (
                                        <>
                                          <span>{roundToOneDecimal(displayValue)}%</span>
                                        </>
                                      )
                                
                                  :  
                                  (<span>{displayValue}</span>)  
                            
                              }
                      </td>
                    </Tooltip>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        </div>}

      </div>
    { viewMode === "grid" && (
      <>
      <br></br>
      <br></br>
      <hr />
      </>
      )
    }
      {/* Drilldown: Color-Clarity Grid */}
      {/* {http://localhost:4000/download_bi_analysis_needs_data_json?seller_account_id=1&start_date=2024-08-18&end_date=2025-08-18&type=turn} */}
      {viewMode === "grid" ? (selectedCell && queryParams.shape && queryParams.carat_range) && (
        <div className="drilldown" >
          <div style={{ paddingTop: '24px', paddingBottom: '40px', paddingLeft: "20px", paddingRight: "20px" }}>
            <div className="pagetitle text-center  justify-center flex-col items-center">                
              {/* <h1>COLOR CLARITY DISTRIBUTION: {selectedCell.shape} / {selectedCell.caratRange}</h1> */}
              <h1 className="mb-7">COLOR CLARITY DISTRIBUTION</h1>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', alignItems: 'center' }}>
                {/* Shape Dropdown */}
                <FormControl size="small">
                      <div className="flex justify-between gap-4 items-center" style={{ minWidth: 450 }}>
                      <InputLabel>Metric</InputLabel>
                        {isAdmin ? 
                        (<Select
                          value={selectedMetric}
                          style={{ minWidth: 162 }}
                          label="Metric"
                        >
                          {["inventory", "sales", "needs", "turn", "current_turn", "overhang", "gross_margin",  "gross_margin_roi"].map((metric) => (
                            <MenuItem key={metric} value={metric} onClick={() => handleMetricChange(metric)}>
                              {metric === "needs" ? "Needs / Surplus" : (metric === "gross_margin_roi" ? "GMROI" : metric === "current_turn" ? "Proj Turn" : metric.charAt(0).toUpperCase() + metric.slice(1).replace("_", " "))}
                            </MenuItem>
                          ))}
                        </Select>) :
                        (<Select
                          value={selectedMetric}
                          style={{ minWidth: 118 }}
                          label="Metric"
                        >
                          {["inventory", "sales", "needs", "turn", "current_turn", "overhang"].map((metric) => (
                            <MenuItem key={metric} value={metric} onClick={() => handleMetricChange(metric)}>
                              {metric === "needs" ? "Needs / Surplus" : metric === "current_turn" ? "Proj Turn" : (metric.charAt(0).toUpperCase() + metric.slice(1).replace("_", " "))}
                            </MenuItem>
                          ))}
                        </Select>)
                        }
                        <div style={{ minWidth: 303 }}>
                            {selectedMetric === "needs" && (
                              <RadioGroup
                              row
                              aria-labelledby="metric-row-radio-buttons-group-label"
                              name="row-radio-buttons-group"
                              size="small"
                              
                            >
                              {["all", "needs", "surplus"].map((metric) => (
                                <FormControlLabel key={metric} value={metric} control={<Radio size="small"/>} label={metric.charAt(0).toUpperCase() + metric.slice(1)} checked={selectedNeedsMetric === metric} onChange={() => handleNeedsMetricChange(metric)}/>
                              ))}
                          </RadioGroup>
                         )}
                       </div>
                      </div>
                    </FormControl>
                <div className="flex justify-center gap-4 w-max items-center">
                  <div className="flex gap-2 justify-end">
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                     <InputLabel>Shape</InputLabel>
                      <Select
                        value={selectedShape || selectedCell.shape}
                        label="Shape"
                        onChange={(e) => {
                          handleShapeChange(e.target.value);
                          // You might want to reset carat range or do other logic here
                        }}
                      >
                        {shapes.map(shape => (
                          <MenuItem key={shape} value={shape}>
                            {data[shape].trans}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                    {/* Carat Range Dropdown */}
                    <FormControl variant="outlined" style={{ minWidth: 150 }} size="small">
                      <InputLabel>Carat Range</InputLabel>
                      <Select
                        value={selectedCaratRange || selectedCell.caratRange}
                        label="Carat Range"
                        onChange={(e) => handleCaratChange(e.target.value)}
                      >
                        {caratRanges.map(range => (
                          <MenuItem key={range} value={range}>
                            {range}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    
                  </div>
                    <button 
                      className="px-4 py-2 text-blue-500 flex gap-2 ml-auto items-center self-end bg-white rounded-md border hover:bg-blue-600 transition-colors duration-200 text-sm font-medium"
                      onClick={() => handleSearchClick(shapeCaratFilter)}
                      >
                      Pricing Co-Pilot  <FiExternalLink />
                    </button>
                </div>
              </div>
            </div>
            <p ref={drilldownRef}></p>
            <ColorClarityGrid
              // colorClarityData={colorClarityData}
              roundToZeroDecimal={roundToZeroDecimal}
              isAdmin={isAdmin}
              isLab={isLab}
              isMFG={isMFG}
              idealTurn={idealTurn}
              idealInterest={idealInterest}
              isResetting={isResetting}
              formatTooltipPriceM={formatTooltipPriceM}
              isCsr={isCsr}
              selectedShape={selectedShape}
              setSelectedShape={setSelectedShape}
              selectedCaratRange={selectedCaratRange}
              setSelectedCaratRange={setSelectedCaratRange}
              // setQueryParams={setQueryParams}
              handleShapeChange={handleShapeChange}
              handleCaratChange={handleCaratChange}
              queryParams={queryParams}
              shape={selectedCell.shape}
              caratRange={selectedCell.caratRange}
              selectedMetric={selectedMetric}
              selectedNeedsMetric={selectedNeedsMetric}
              highlightedGroup={hoveredGroup} // Pass hovered group to detailed view
              setHoveredGroup={setHoveredGroup} // Pass hovered group to detailed view
              gridData={gridData}
              data={data}
              shapes={shapes}
              caratRanges={caratRanges}
              filtered={filteredRedux}
              onCellClick={(color, clarity) =>
                console.log("Color:", color, "Clarity:", clarity)
              }
            />
          </div>
        </div>
      ) : (
          <div className="flex justify-center mt-4">
            <BiAnalysisTable data={tableViewData} isAdmin={isAdmin}
              isMFG={isMFG} queryParams={queryParams} showLoadingTable={showLoadingTable} />
          </div>
        )}
    </div>
  );
};

ShapeCaratGrid.propTypes = {
  caratRanges: PropTypes.arrayOf(PropTypes.string).isRequired,
  shapes: PropTypes.arrayOf(PropTypes.string).isRequired,
  gridData: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        inventory: PropTypes.number.isRequired,
        sales: PropTypes.number.isRequired,
        needs: PropTypes.number.isRequired,
        turn: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
          .isRequired,
      })
    )
  ).isRequired,
  dateRange: PropTypes.shape({
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  }).isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
  defaultMetric: PropTypes.oneOf(["inventory", "sales", "needs", "turn"]),
};

export default ShapeCaratGrid;
